
















































































import Vue from "vue";
import { Component } from "vue-property-decorator";

import VueApexCharts from "vue-apexcharts";
import { patientRecordsModule } from "@/store/modules/patientRecords";
import {
  CHARTMEASUREITEM,
  MEASUREITEM,
  MEASUREMENT_STATUS,
  MEASUREMENT_COLORS
} from "@/utils/store-util";
Vue.use(VueApexCharts);

interface STASUS {
  value: number;
}

@Component({
  components: {
    VueApexCharts
  }
})
export default class RecordChart extends Vue {
  chartOptions = {};
  series = [];
  mearsumentAt = [];
  mearsumentValue = [];
  mearsumentGoodValue = [];
  mearsumentWarningValue = [];
  mearsumentBadValue = [];
  selected = [];

  measureTypeShow = ["blood_pressure", "blood_glucose","spo2"];
  measurement = CHARTMEASUREITEM
  switchMask = true;

  STATUS_GOOD: STASUS = {
    value: 0
  };
  STATUS_WARNING: STASUS = {
    value: 0
  };
  STATUS_BAD: STASUS = {
    value: 0
  };

  recordsOptions = {
    q: "",
    order: "asc",
    sort: "",
    uuid: "",
    limit: -1,
    formatMeasureAt: false,
    range: "7,d"
  };

  async created() {
    this.recordsOptions.uuid = this.$router.currentRoute.params.id;
    this.changeRange();
  }

  async changeRange() {
    this.resetChart();
    patientRecordsModule.clearRecord();
    await patientRecordsModule.getPatientRecordByUuid(this.recordsOptions);
    this.update();
  }

  color(status) {
    return MEASUREMENT_COLORS[status];
  }

  async update() {
    let measurementName = "systolic";
    if (this.selected.length) {
      measurementName = this.selected[0].name_en;
    }
    await this.resetChart();
    await this.getDataByCategory(measurementName);
    await this.updataChart();
  }

  updataChart() {
    this.series = [
      {
        name: "測量值",
        data: this.mearsumentValue
      },
      {
        name: "警告值",
        data: this.mearsumentWarningValue
      },
      {
        name: "異常值",
        data: this.mearsumentBadValue
      }
    ];
    this.chartOptions = {
      xaxis: {
        type: "datetime",
        categories: this.mearsumentAt
      },
      yaxis: {
        labels: {
          minWidth: 10
        }
      },
      zoom: {
        enabled: false
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: [3, 3, 3],
        curve: "straight",
        dashArray: [0, 3, 3]
      },
      markers: {
        size: [6, 0, 0],
        hover: {
          sizeOffset: 10
        }
      },
      grid: {
        borderColor: "#f1f1f1"
      },
      colors: ["#757575", MEASUREMENT_COLORS[1], MEASUREMENT_COLORS[2]],
      tooltip: {
        enabledOnSeries: [0]
      }
    };
  }

  resetChart() {
    this.chartOptions = {};
    this.mearsumentAt = [];
    this.mearsumentValue = [];
    this.mearsumentGoodValue = [];
    this.mearsumentWarningValue = [];
    this.mearsumentBadValue = [];
  }

  async getDataByCategory(name: string) {
    const data = this.items.filter(data => data.key === name);
    for (const d of data) {
      this.mearsumentAt.push(
        d.measure_at.substring(5, d.measure_at.length - 3)
      );
      this.mearsumentValue.push(d.value);
    }

    // GOOD
    this.STATUS_GOOD = this.measurementTypes[name].rule.find(r => {
      return r.result === MEASUREMENT_STATUS.GOOD;
    });

    if (this.STATUS_GOOD) {
      this.mearsumentGoodValue = data.map(() => this.STATUS_GOOD.value);
    }

    // WARNING
    this.STATUS_WARNING = this.measurementTypes[name].rule.find(r => {
      return r.result === MEASUREMENT_STATUS.WARNING;
    });
    if (this.STATUS_WARNING) {
      this.mearsumentWarningValue = data.map(() => this.STATUS_WARNING.value);
    }

    // BAD
    this.STATUS_BAD = this.measurementTypes[name].rule.find(r => {
      return r.result === MEASUREMENT_STATUS.BAD;
    });
    if (this.STATUS_BAD) {
      this.mearsumentBadValue = data.map(() => this.STATUS_BAD.value);
    }
  }

  cancel() {
    this.resetChart();
    this.$router.push({ name: "個案紀錄" });
  }

  get items() {
    return patientRecordsModule.items;
  }

  get measurementTypes() {
    return patientRecordsModule.measurementTypes;
  }

  get loading() {
    return patientRecordsModule.loading;
  }

  get patient() {
    return patientRecordsModule.patient;
  }
}
